import { render, staticRenderFns } from "./ManipulationMenu.vue?vue&type=template&id=787c833a&scoped=true"
import script from "./ManipulationMenu.vue?vue&type=script&lang=js"
export * from "./ManipulationMenu.vue?vue&type=script&lang=js"
import style0 from "./ManipulationMenu.vue?vue&type=style&index=0&id=787c833a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787c833a",
  null
  
)

export default component.exports